export default __webpack_public_path__ + "static/media/nutri.279264a5.svg";